import { Dictionary } from 'lodash';
import { useCallback } from 'react';
import { Team } from 'api/models';
import {
  SocketDataForTeam,
  TeamWithAdditionalInfo,
} from 'api/resource-management/types';
import { useAddTeamToLocalState } from 'queries/placeholder';

export const useAddTeamToProjectWSHandler = (): ((
  projectId: number,
  data: SocketDataForTeam,
  teamLookup: Dictionary<Team>,
) => Team | undefined) => {
  const addTeamToLocalState = useAddTeamToLocalState();

  return useCallback(
    (
      projectId: number,
      data: SocketDataForTeam,
      teamLookup: Dictionary<Team>,
    ): Team | undefined => {
      const { teamId } = data;

      // * There are two scenarios when addTeamHandler will be invoked
      // * 1. When a new placeholder is created, socketData will have all Team fields
      // * 2. When an account-level placeholder is added to a project

      const team =
        (data as TeamWithAdditionalInfo).projectId != null
          ? (data as Team)
          : teamLookup[teamId];

      if (team != null) {
        addTeamToLocalState(projectId, team);
      }

      return team;
    },
    [addTeamToLocalState],
  );
};
